<template>
  <div class="synchronous">
    <div class="synchronous-header">
      <div>
        <el-button type="primary" @click="handelAddCouponBtn(null)">新增京东福利券</el-button>
<!--        <span class="synchronous-header-tip">点击该按钮后，手动同步对应快手ID的商品到我们自己数据库，主要同步列表信息和商品适用门店。</span>-->
      </div>
      <div class="forms-container">
        <el-form :model="searchForm" class="search-form" ref="searchFormRef">
          <el-form-item label="商品券编码" prop="templateCode">
            <el-input
              style="width:200px"
              :maxlength="255"
              v-model="searchForm.templateCode"
              placeholder="请输入商品劵编码"
            />
          </el-form-item>
          <el-form-item
            label="券名称"
            prop="name"
          >
            <el-input
              style="width:170px"
              :maxlength="255"
              v-model="searchForm.name"
              placeholder="请输入券名称"
            />
          </el-form-item>
          <el-form-item>
            <!-- 操作按钮 -->
            <el-button type="warning" @click="onFormSearch">查询</el-button>
            <el-button type="warning" plain @click="onFormReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

  <my-table
    :tableData="table.tableData"
    :headerList="table.headerList"
    :loading="table.loading"
    :page-size="params.pageSize"
    :currentPage="params.pageNo"
    :total="table.total"
    @currentPage-change="handlePageChange"
    @sizePage-change="handleSizeChange"
  >
    <!-- 自定义内容 -->
    <template v-slot:startTime="{ data }">
      <div>开始：{{data.startTime}}</div>
      <div>结束：{{data.endTime}}</div>
    </template>
    <template v-slot:templateCode="{data}">
      <div style="display: flex;justify-content: space-between;">
        <span>{{data.templateCode}}</span>
        <el-link type="primary"
                 v-clipboard:copy="data.templateCode"
                 v-clipboard:success="onCopy"
                 v-clipboard:error="onError"
        >复制</el-link>
      </div>
    </template>
    <template v-slot:name="{data}">
      <div style="display: flex;justify-content: space-between;">
        <span>{{data.name}}</span>
        <el-link type="primary"
                 v-clipboard:copy="data.name"
                 v-clipboard:success="onCopy"
                 v-clipboard:error="onError"
        >复制</el-link>
      </div>
    </template>
    <template v-slot:stock="{ data }">
      {{data.stock}}/{{data.totalStock}}
    </template>
    <!-- 自定义内容 -->
    <template v-slot:cinemaNum="{ data }">
      <div v-if="data.cinemaFilterType === 0">全部影院</div>
      <div v-else>{{data.cinemaNum}}</div>
    </template>
    <template v-slot:operation="{ data }">
      <div style="display: flex;">
        <el-link type="primary" @click="handelAddCouponBtn(data)">查看</el-link>
        <el-link v-if="data.stock" style="margin-left: 8px;" type="primary" @click="handelExportCouponBtn(data)">导出券码</el-link>
      </div>
    </template>
  </my-table>
    <createCoupon ref="createCouponRef" @updateDy="updateDy"> </createCoupon>
    <exportCoupon ref="exportCouponRef" @updateDy="updateDy"></exportCoupon>
  </div>
</template>

<script>
import mini from "@/api/mini";
const MiniModel = new mini();
import myTable from '@/components/my-table.vue'
import debounce from "@/utils/debounce.js";
import createCoupon from "./component/createCoupon.vue";
import exportCoupon from "./component/exportCoupon.vue";

export default {
  components: {
    createCoupon,
    myTable,
    exportCoupon,
  },
  data() {
    return {
      searchForm: {
        templateCode: '',
        name: ''
      },
      params: {
        pageNo: 1,
        pageSize: 10,
      },
      table: {
        loading: false,
        total: 0,
        tableData: [],
        headerList: [
          {
            prop: 'createTime',
            label: '创建时间',
            width: '180',
            // customRender:'customName'
          },
          {
            prop: 'templateCode',
            label: '商品券编码',
            width: '200',
            customRender: 'templateCode',
          },
          {
            prop: 'name',
            label: '券名称',
            width: '200',
            customRender: 'name',
          },
          {
            prop: 'originalPriceBd',
            label: '面值（元）',
            width: '100'
          },
          {
            prop: 'sellPriceBd',
            label: '售价（元）',
            width: '100'
          },
          {
            prop: 'startTime',
            label: '有效时间',
            customRender: 'startTime',
            width: '230',
          },
          {
            prop: 'stock',
            label: '库存',
            width: '120',
            customRender: 'stock',
          },
          {
            prop: 'cinemaNum',
            label: '适用影院数量',
            width: '120',
            customRender: 'cinemaNum',
          },
          {
            prop: 'useCondition',
            label: '适用座位',
          },
          {
            prop: 'operation',
            label: '操作',
            width: '150',
            customRender: 'operation',
            fixed: 'right', //是否固定列
          }
        ]
      },
      productStatusList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "已上架",
          value: 1,
        },
        {
          label: "已下架",
          value: 2,
        },
        {
          label: "已售罄",
          value: 3,
        },
        {
          label: "已删除",
          value: 5,
        },
      ],
    }
  },
  created() {
    this.getTbLifeCouponQueryList()
  },
  methods: {
    handelExportCouponBtn(row) {
      console.log(row, 'row')
      this.$refs.exportCouponRef.open(row)
    },
    updateDy() {
      this.params.pageNo = 1
      this.params.pageSize = 10
      this.getTbLifeCouponQueryList();
    },
    // 自定义的数字校验规则
    validateNumber(rule, value, callback) {
      if (value === '') {
        // 如果值为空，不做任何校验
        callback();
      } else if (!/^\d+$/.test(value)) {
        // 如果值不为空，并且不是数字，报错
        callback(new Error('请输入数字'));
      } else {
        // 如果值是数字，校验通过
        callback();
      }
    },
    // 表单搜素
    onFormSearch() {
      debounce(
        () => {
          this.$refs['searchFormRef'].validate((valid) => {
            if (valid) {
              this.params.pageNo = 1;
              this.getTbLifeCouponQueryList();
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        500,
        true
      );
    },
    onFormReset() {
      debounce(() => {
        this.searchForm = {
          templateCode: '',
          productStatus: '',
          name: ''
        }
        this.$refs['searchFormRef'].resetFields();
        this.getTbLifeCouponQueryList()
      }, 1000, true)
    },
    handelFlushed() {
      debounce(() => {
        this.getTbLifeCouponQueryList()
      }, 1500, true)
    },
    reset() {
      this.params = {
        pageNo: 1,
        pageSize: 10,
      }
      this.getTbLifeCouponQueryList()
    },
    // 淘宝天猫券列表查询
    async getTbLifeCouponQueryList() {
      let appKeyMini = localStorage.getItem("appKeyMini");
      this.table.loading = true;
      const res = await MiniModel.jdCouponSearch({...this.params, appKey: appKeyMini,...this.searchForm}).finally(() => {
        this.table.loading = false;
      })
      console.log(res, 'res==淘宝天猫券列表查询')
      if (res.data.code === 200) {
        this.table.tableData = res.data.data.list.map(item => {
          return {
            ...item,
          }
        })
        this.table.total = res.data.data.total;
        this.params.pageNo = res.data.data.pageNo
        console.log(this.table.tableData, 'this.table.tableData')
      } else {
        this.$message({
          message: res.data.message,
          type: 'error'
        });
      }
    },
    handelAddCouponBtn(row) {
      this.$refs.createCouponRef.open(row)
    },
    // 分页
    handlePageChange(val) {
      this.params.pageNo = val
      this.getTbLifeCouponQueryList()
    },
    // 每页显示条数
    handleSizeChange(val) {
      this.params.pageSize = val
      this.getTbLifeCouponQueryList()
    },
    //复制
    onCopy: function(e) {
      this.$Message.success('复制成功');
    },
    onError: function(e) {
      this.$Message.success('复制失败');
    },
  }
}
</script>

<style scoped lang="less">
.synchronous {
  &-header {
    //display: flex;
    //justify-content: space-between;
    //align-items: center;
    &-tip{
      color: #666;
      margin-left: 10px;
      font-size: 12px;
    }
    &__icons{
      i{
        font-size: 22px;
        cursor: pointer;
        margin-right: 50px;
        color: #409eff;
      }
    }
  }
}
.forms-container{
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/couponJd/TbCouponSynchronous.vue